import {Slide} from "@mui/material";
import Modal from "@mui/material/Modal";
import {useEffect, useRef, useState} from "react";
import GlossaryDetailedScreenHeader from "../../components/others/glossaryScreen/GlossaryDetailedScreenHeader";
import GlossaryDetailedScreenContent from "../../components/others/glossaryScreen/GlossaryDetailedScreenContent";
import GlossaryDetailedScreenSubHeader from "../../components/others/glossaryScreen/GlossaryDetailedScreenSubHeader";
import {kGlossaryTexts} from "../../constants/texts";
import SystemModalClosingVoid from "../../components/others/SystemModalClosingVoid";

export default function GlossaryDetailedScreen({ open,
                                                 handleClose,
                                                 term }) {
    // Used in CoursesLevelAItem to display side modal
    // with levelA details and action buttons

    // PROPERTIES
    const [currentTab, setCurrentTab] = useState(kGlossaryTexts.definitionTab);
    const modalRef = useRef();

    // HOOKS
    // ---- At rendering
    useEffect(() => {
        if (!open) {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }
    }, [open]);

    // BUILD
    return (
        <Modal open={open}
               onClose={handleClose}
               disableEnforceFocus>
            <Slide direction="left" in={open} mountOnEnter unmountOnExit>
                <div ref={modalRef}
                     className="overflow-auto w-full h-[100svh] flex outline-none">
                    <SystemModalClosingVoid handleClose={handleClose} />
                    <div className="bg-backgroundLight3 w-[416px] min-w-[416px] h-full flex flex-col justify-between overflow-hidden">
                        <GlossaryDetailedScreenHeader term={term}
                                                      handleClose={handleClose} />
                        <GlossaryDetailedScreenSubHeader currentTab={currentTab}
                                                         onTabPressed={onTabPressed}  />
                        <GlossaryDetailedScreenContent term={term}
                                                       currentTab={currentTab} />
                    </div>
                </div>
            </Slide>
        </Modal>
    );

    // METHODS
    // ---- On sub header tab pressed
    function onTabPressed(tab) {
        setCurrentTab(tab)
    }
}